import { Common } from '@stockbit/ui';
import PropTypes from 'prop-types';
import React from 'react';

import { HeaderContainer } from './styled';

const { Text } = Common;

interface HeaderProps {
  children: React.ReactNode;
  [key: string]: any;
}

const Header = ({ children, ...props }: HeaderProps) => (
  <HeaderContainer {...props}>
    <Text size="1rem" height="40px" family="bold">
      {children}
    </Text>
  </HeaderContainer>
);

Header.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Header;
